import { homePageActions } from './HomeAction';

const initState = {
    showSpinner: false,
    activeProgram: null,
    error: null,
}

export default function homePageReducer(state=initState, action) {
    switch (action.type) {
        case homePageActions.setActiveProgramId:
            return setActiveProgramId(state, action);
        case homePageActions.setError:
            return setError(state, action);
        case homePageActions.toggleSpinner:
            return toggleSpinner(state, action);
        default:
            return state;
    }
}

function setActiveProgramId(state, {payload}) {
    return {
        ...state,
        activeProgram: payload,
    }
}

function setError(state, {payload}) {
    return {
        ...state,
        error: payload,
    }
}

function toggleSpinner(state, {payload}) {
    return {
        ...state,
        showSpinner: payload,
    }
}